import { render } from "./xlEcharts.vue?vue&type=template&id=713170a4&scoped=true"
import script from "./xlEcharts.vue?vue&type=script&lang=js"
export * from "./xlEcharts.vue?vue&type=script&lang=js"

import "./xlEcharts.vue?vue&type=style&index=0&id=713170a4&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713170a4"]])

export default __exports__